import { z } from 'zod';
import { hexColorSchema } from './common';

export const BrandAssetKind = {
  LOGO_PRIMARY: 'LOGO_PRIMARY',
  LOGO_LIGHT: 'LOGO_LIGHT',
  LOGO_DARK: 'LOGO_DARK',
  LOGO_ICON: 'LOGO_ICON',
  FONT: 'FONT',
  BACKGROUND: 'BACKGROUND',
  PATTERN: 'PATTERN',
  PHOTO: 'PHOTO',
  DOCUMENT: 'DOCUMENT',
  OTHER: 'OTHER',
} as const;
export type BrandAssetKind = (typeof BrandAssetKind)[keyof typeof BrandAssetKind];

export const brandIdentitySchema = z.object({
  primaryColor: hexColorSchema,
  secondaryColor: hexColorSchema.optional(),
  accentColor: hexColorSchema.optional(),
  backgroundColor: hexColorSchema.default('#FFFFFF'),
  textColorOnPrimary: hexColorSchema.default('#FFFFFF'),
  textColorOnBackground: hexColorSchema.default('#111111'),
  headingFontFamily: z.string().max(120).default('Inter'),
  bodyFontFamily: z.string().max(120).default('Inter'),
  /** Estilo visual repassado ao gerador de imagens (sem texto). */
  imageStyleGuide: z.string().max(2000).optional(),
  logoSafeAreaPct: z.number().min(0).max(30).default(6),
  defaultCta: z.string().max(80).default('Assine agora'),
  legalFooter: z.string().max(500).optional(),
});
export type BrandIdentityInput = z.infer<typeof brandIdentitySchema>;

export const brandAssetSchema = z.object({
  kind: z.nativeEnum(BrandAssetKind),
  label: z.string().trim().min(1).max(160),
  storageKey: z.string().min(1).max(500),
  mimeType: z.string().max(120),
  sizeBytes: z.number().int().min(0),
  width: z.number().int().min(0).optional(),
  height: z.number().int().min(0).optional(),
  isDefault: z.boolean().default(false),
});
export type BrandAssetInput = z.infer<typeof brandAssetSchema>;

export const MAX_UPLOAD_SIZE_BYTES = 50 * 1024 * 1024;

export const presignUploadSchema = z.object({
  fileName: z.string().trim().min(1).max(255),
  mimeType: z.string().min(3).max(120),
  sizeBytes: z.number().int().min(1).max(MAX_UPLOAD_SIZE_BYTES),
  folder: z.enum(['brand', 'creatives', 'social', 'content', 'reports', 'temp']).default('temp'),
});
export type PresignUploadInput = z.infer<typeof presignUploadSchema>;

export const ALLOWED_UPLOAD_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
  'image/gif',
  'video/mp4',
  'application/pdf',
  'font/ttf',
  'font/otf',
  'font/woff',
  'font/woff2',
];
